export const FILTER_HEADING_PADDING = 10;
export const FILTER_CONTENT_PADDING = 15;
